import { delayedCall, dispatcher, EventConstants, ingenuity, killDelayedCall } from "@quest/base-core";
import { SettingPannelController, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";

export class SettingPanelControllerGame extends SettingPannelController {
  protected subscribeEvents() {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.RESIZE_SETTING_PANEL_ON_ORIENTATION, this.resizeSettingsPanel, this);
  }
  protected unsubscribeEvents() {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.RESIZE_SETTING_PANEL_ON_ORIENTATION, this.resizeSettingsPanel, this);
  }
  /**
   * Override to show wild reels, bonus & chilli panel progress on max button pressup
   */
  protected onMaxBetPressUp(): void {
    super.onMaxBetPressUp();
    dispatcher.fireEvent(eventDispatchers.HANDLE_FEATURE_ON_BET_CHANGE);
  }

  /**
   * Override to show wild reels, bonus & chilli panel progress on bet change
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.HANDLE_FEATURE_ON_BET_CHANGE);
  }

  // Overrided to handle setting panel resize
  protected toggleToBetSettingsPage() {
    if (this.betSettingsView.style.display === SlotConstantsBehavior.DISPLAY_NONE) {
      super.toggleToBetSettingsPage();
      this.resizeSettingsPanel();
      dispatcher.fireEvent(EventConstants.BUTTON_RELESED, SlotConstantsBehavior.InfoBtnId);
    }
  }
  // Overrided to handle setting panel resize
  protected showView(): void {
    super.showView();
    this.resizeSettingsPanel();
  }
  // Overrided to handle setting panel resize
  protected toggleToHelpPage() {
    ingenuity.configData.isBSPOTEnable && this.updatePayouts();
    this.infoContainerDiv.style.display === SlotConstantsBehavior.DISPLAY_NONE &&
      (dispatcher.fireEvent(EventConstants.BUTTON_RELESED, gameConstants.HelpPage), super.toggleToHelpPage());
  }
  // Setting panel resize
  private resizeSettingsPanel(): void {
    delayedCall(
      "resizeDleay",
      10,
      () => {
        killDelayedCall("resizeDleay");
        const spC = document.getElementById("SP-Container");
        const spO = document.getElementById("SP-Options");
        const spM = document.getElementById("SP-Menu");
        const newTopPosition = (spC.offsetHeight - spO.offsetHeight - spM.offsetHeight) / 2 - 6;
        document.getElementById("SP-Content").style.marginTop = `${newTopPosition}px`;
      },
      this
    );
  }

  protected showHelp(): void {
    ingenuity.configData.isBSPOTEnable && this.updatePayouts();
    super.showHelp();
  }

  private updatePayouts(): void {
    gameConstants.SYMBOL_ID_LIST?.forEach((symID: number) => {
      let paytableData: any = (ingenuity.parserModel as GameParserModel).getPaytableData()[symID];
      if(symID === gameConstants.WILD_EXTRA_ID){
        paytableData = (ingenuity.parserModel as GameParserModel).getPaytableData()[gameConstants.WILD_ID]
      }
      gameConstants.OFAKIND_PAYOUT_ID?.forEach((field: string) => {
        const span: any = document?.querySelector(`#symbol_${symID} .${field}`);
        if (span) {
          span.textContent = this.setCurrencyFormattedValue(
            String(
              (paytableData.values[field[field.length - 1]] * ingenuity.parserModel.getCurrentTotalBet()) /
                gameConstants.CREDIT_CONVERSION
            )
          );
        }
      });
    });
  }
}
